/** Возвращает строку, в которой первая буква прописная, а все остальные без изменений */
export const capitalize = (str: string): string => {
  if (str === '') {
    return str;
  }

  return str[0].toUpperCase() + str.slice(1);
};
